var map = {
	"./dice.webp": 1681,
	"./esports-bg.webp": 1682,
	"./esports-ctg.webp": 1683,
	"./im-img.webp": 1684,
	"./im-title-cn.webp": 1685,
	"./im-title-en.webp": 1686,
	"./imone-img.webp": 1687,
	"./imone-title-cn.webp": 1688,
	"./imone-title-en.webp": 1689,
	"./snooker.webp": 1690,
	"./spade.webp": 1691,
	"./tfg-img.webp": 1692,
	"./tfg-title-cn.webp": 1693,
	"./tfg-title-en.webp": 1694
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1680;